<template>
  <div>
    <b-row class="align-items-center mx-0">
      <b-form-group
        label="Tipos de Instituições"
        :state="validateState('tipos_instituicoes')"
        v-slot="{ ariaDescribedby }"
      >
        <b-form-checkbox-group
          v-model="selectedOptions"
          stacked
          name="tipos_instituicoes"
          :options="formattedInstituicoes"
          :aria-describedby="ariaDescribedby"
        />
        <b-form-invalid-feedback :state="validateState('tipos_instituicoes')">
          Selecione pelo menos um tipo de instituição
        </b-form-invalid-feedback>
      </b-form-group>
    </b-row>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import safeArray from "lodash/toArray";

import TiposInstituicoes from "@/modules/clientes/Components/Form/TiposInstituicoes.vue";

export default {
  mixins: [validationMixin],
  components: { TiposInstituicoes },
  data: () => ({
    instituicoes: [],
  }),
  validations: {
    plano: {
      tipos_instituicoes: {
        required,
      },
    },
  },
  computed: {
    ...mapState("planos", ["plano"]),
    formattedInstituicoes() {
      return safeArray(this.instituicoes).map((instituicao) => ({
        text: instituicao.nome,
        value: instituicao.id,
      }));
    },
    selectedOptions: {
      get() {
        return safeArray(this.plano.tipos_instituicoes).map((instituicao) =>
          typeof instituicao === "number" ? instituicao : instituicao.id
        );
      },
      set(value) {
        this.plano.tipos_instituicoes = value;
      },
    },
  },
  methods: {
    ...mapActions("tipos_instituicoes", ["ActionFind"]),
    validateState(name) {
      const { $dirty, $error } = this.$v.plano[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.plano.$touch();
      return !this.$v.plano.$anyError;
    },
    reset() {
      this.$v.$reset();
    },
  },
  async created() {
    const response = await this.ActionFind({ per_page: 100 });
    this.instituicoes = response.data;
  },
};
</script>
